import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "redux/hooks";

import { useMediaQuery } from "context/media/MediaContext";
import { TokenInclude } from "helpers/GetToken";
import { setActive } from "redux/slices/EmployeeManagementSlice";
import { SetEmployeeOperations } from "services/employeeManagement.service";

import Button from "../../BaseComponents/Button";
import Modal from "../../BaseComponents/Modal";
import { Col, Row, Seperator } from "../../BaseComponents/Flex";
import InsideSpinner from "components/BaseComponents/Spinner/InsideSpinner";
import { setIsModalActive } from "redux/slices/simBlockModalSlice";

interface EmployeeEditModalProps {
  title?: string;
  message?: string;
  acceptButtonText?: string;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  rejectButtonText?: string;
  phoneNumber: string;
  name: string;
  isSim: boolean;
}

const EmployeeEditModal: FC<EmployeeEditModalProps> = ({
  title,
  message,
  acceptButtonText,
  rejectButtonText,
  setIsOpen,
  phoneNumber,
  name,
  isSim,
}) => {
  const navigate = useNavigate();
  const { isMobile } = useMediaQuery();
  const dispatch = useAppDispatch();
  const token = TokenInclude();

  const [loading, setLoading] = useState<boolean>(false);
  const [pn, setpn] = useState("");
  const [nm, setnm] = useState("");

  const onAcceptClick = async () => {
    setLoading(true);
    const isActive = await SetEmployeeOperations(token, pn, "1");
    if (isActive.Issucceeded) {
      dispatch(setActive(phoneNumber));
      setIsOpen(false);
      setLoading(false);
      if (!isSim) {
        navigate(`/edit-agent/${nm}/${pn}`);
      } else {
        dispatch(setIsModalActive(true));
      }
    }
  };

  const onRejectClick = (): void => {
    dispatch(setIsModalActive(false));
    setIsOpen(false);
  };

  useEffect(() => {
    phoneNumber && setpn(phoneNumber);
    name && setnm(name);
  }, [phoneNumber, name]);

  return (
    <Modal info={message} maxWidth={450} setIsOpen={setIsOpen} title={title}>
      <Row justifyContent='center' isResponsive noMargin>
        <Col size={0.3}>
          <Button
            color='light'
            onClick={onAcceptClick}
            text={
              loading ? (
                <InsideSpinner width='30' height='30' isWhite={true} />
              ) : (
                acceptButtonText
              )
            }
          />
        </Col>

        <Seperator marginRight={20} marginTop={isMobile ? 10 : 0} />

        <Col size={0.3}>
          <Button onClick={onRejectClick} text={rejectButtonText} />
        </Col>
      </Row>
    </Modal>
  );
};

export default EmployeeEditModal;
